import { FC } from 'react';
import { AdditionalFeature } from '../../interfaces/domain/ow-app.modal';
import OWLink from '../shared/ow-link';

// -----------------------------------------------------------------------------
interface TagProps {
  list: AdditionalFeature[];
}

// -----------------------------------------------------------------------------
export const FeaturedTagList: FC<TagProps> = ({list}): JSX.Element => {
  if (!list || list.length === 0) {
    return (<></>);
  }

  return (
    <>
      {list.map((tagItem, index) => {
        const className = tagItem.url ? 'tag-item-link' : 'tag-item';

        return (
          <li className={className} key={index}>
            {tagItem.url && 
              <OWLink href={tagItem.url}>
                {tagItem.icon &&
                  <img src={tagItem.icon} alt={tagItem.name} />
                }
                {tagItem.name}
              </OWLink>
            }
            {!tagItem.url && 
              <>
                {tagItem.icon &&
                  <img src={tagItem.icon} alt={tagItem.name} />
                }
                {tagItem.name}
              </>
            }
          </li>
        );

      })}
    </>
  );
};
